import { createSlice } from '@reduxjs/toolkit';
import { IPermissions, User } from '../../types/user';

export interface UserState {
  token: string;
  isAuthenticated: boolean;
  isInitialized: boolean;
  user?: User;
  userData: any;
  sessionExpired: boolean;
  permissions: IPermissions | null;
}

const initialState: UserState = {
  token: '',
  userData: null,
  isAuthenticated: false,
  isInitialized: false,
  sessionExpired: false,
  permissions: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action) {
      state.userData = action?.payload;
    },
    setSessionExpired(state, action) {
      state.sessionExpired = action?.payload;
    },
    setPermissions(state, actions) {
      state.permissions = actions.payload;
    },
  },
});

export const { setUser, setSessionExpired, setPermissions } = userSlice.actions;
export default userSlice.reducer;
